import React from 'react'
import Layout from '../components/layout/Layout'
import Seo from '../components/Seo'
import { Link } from 'react-router-dom'
import { ArrowLeft } from 'lucide-react'

const PrivacyPolicy: React.FC = () => {
  return (
    <Layout>
      <Seo title="Polityka prywatności — 2domy.pl" canonical="https://2domy.pl/polityka-prywatnosci" robots="index,follow" />
      <div className="max-w-4xl mx-auto px-4 py-10">
        <div className="mb-4">
          <Link to="/" className="inline-flex items-center text-slate-700 hover:text-slate-900">
            <ArrowLeft className="h-4 w-4 mr-2" /> Powrót do strony głównej
          </Link>
        </div>
        <div className="card-glass p-8 sm:p-12">
          <h1 className="text-3xl sm:text-4xl font-bold mb-2 bg-gradient-to-r from-slate-700 to-slate-900 bg-clip-text text-transparent">
            Polityka prywatności 2domy.pl
          </h1>
          <p className="text-sm text-slate-500 mb-8">Ostatnia aktualizacja: 9 lutego 2026 r.</p>

          <div className="prose prose-slate max-w-none">
            <h2>1) Administrator danych</h2>
            <p>
              Administratorem Twoich danych osobowych jest AITRAIN Marcin Opinc, ul. Kaszubska 6/21, 83-110 Tczew, Polska,
              NIP: 5831541445, e-mail: <a href="mailto:kontakt@2domy.pl">kontakt@2domy.pl</a> ("Administrator", "my").
            </p>

            <h2>2) Zakres i cel dokumentu</h2>
            <p>
              Ta Polityka wyjaśnia, jakie dane przetwarzamy w związku z korzystaniem z serwisu 2domy.pl i aplikacji webowej (PWA) ("Serwis"), w jakich celach, na jakiej podstawie prawnej, jak długo, komu je udostępniamy oraz jakie masz prawa.
              Serwis nie wyświetla reklam i nie prowadzi profilowania reklamowego.
            </p>

            <h2>3) Kategorie danych, które przetwarzamy</h2>
            <ul className="list-disc ml-5 space-y-1">
              <li><strong>Dane konta:</strong> e-mail, hasło (zaszyfrowane), imię/pseudonim, ustawienia konta.</li>
              <li><strong>Dane usługi:</strong> treści dodane w Serwisie (np. wydarzenia kalendarza, listy, notatki, zadania, pliki – jeśli funkcja jest używana).
              </li>
              <li><strong>Dane rozliczeniowe:</strong> informacje o subskrypcji, status płatności, identyfikatory transakcji. Nie przetwarzamy danych karty płatniczej – obsługuje to operator płatności.</li>
              <li><strong>Dane techniczne/eksploatacyjne:</strong> adres IP, identyfikatory urządzeń i sesji, logi serwera, dane o błędach.</li>
              <li><strong>Dane analityczne (Google Analytics)</strong> – zagregowane dane o ruchu i zachowaniu użytkowników. Wykorzystujemy mechanizm Google Consent Mode v2, który dostosowuje działanie tagów Google w zależności od Twojej zgody (ograniczając przetwarzanie do pingów bez plików cookie przy braku zgody).</li>
              <li><strong>Pliki cookie i podobne technologie</strong> – szczegóły w Polityce plików cookie.</li>
            </ul>

            <h2>4) Cele i podstawy prawne (RODO art. 6)</h2>
            <table>
              <thead>
                <tr><th>Cel</th><th>Podstawa prawna</th></tr>
              </thead>
              <tbody>
                <tr><td>Założenie i obsługa konta, świadczenie usługi 2domy.pl</td><td>niezbędność do wykonania umowy (art. 6 ust. 1 lit. b)</td></tr>
                <tr><td>Płatności online (Stripe), księgowanie i obsługa reklamacji</td><td>niezbędność do umowy (b), obowiązek prawny (c)</td></tr>
                <tr><td>Obsługa zgłoszeń, komunikacja e-mail</td><td>uzasadniony interes (f)</td></tr>
                <tr><td>Utrzymanie bezpieczeństwa Serwisu (logi, ochrona przed nadużyciami)</td><td>uzasadniony interes (f)</td></tr>
                <tr><td>Analityka (Google Analytics 4, w trybie zgodnym z UE)</td><td>zgoda (a)</td></tr>
                <tr><td>Ewidencja zgód cookie (identyfikator zgody, kategorie, User Agent, data)</td><td>obowiązek prawny — rozliczalność (art. 5 ust. 2, art. 7 ust. 1 RODO) (c)</td></tr>
                <tr><td>Dochodzenie i obrona roszczeń</td><td>uzasadniony interes (f)</td></tr>
                <tr><td>Rozliczenia księgowe/podatkowe</td><td>obowiązek prawny (c)</td></tr>
              </tbody>
            </table>

            <h2>5) Odbiorcy danych</h2>
            <p>Twoje dane mogą być udostępniane następującym kategoriom podmiotów:</p>
            <ul className="list-disc ml-5 space-y-1">
              <li><strong>Operator płatności:</strong> Stripe Payments Europe, Limited – niezależny administrator danych płatniczych.</li>
              <li><strong>Hosting i infrastruktura:</strong> Vercel Inc. – hosting i uruchamianie aplikacji.</li>
              <li><strong>Baza danych:</strong> Supabase Inc. – baza danych i API.</li>
              <li><strong>E-mail/SMTP:</strong> Resend Inc. – wysyłka powiadomień i wiadomości systemowych.</li>
              <li><strong>Analityka:</strong> Google Ireland Limited – Google Analytics 4 (jeśli wyrazisz zgodę).</li>
              <li><strong>Ewidencja zgód:</strong> Google Ireland Limited (Google Apps Script/Sheets) – przechowywanie dowodów wyrażenia lub zmiany zgody cookie (identyfikator zgody, wybrane kategorie, User Agent przeglądarki, data). Dane nie zawierają adresu e-mail ani innych danych bezpośrednio identyfikujących osobę.</li>
              <li><strong>Księgowość i obsługa prawna</strong> – w zakresie niezbędnym do rozliczeń i ochrony prawnej.</li>
            </ul>
            <p>Z każdym podmiotem przetwarzającym zawieramy umowę powierzenia przetwarzania danych (DPA). W przypadku globalnych dostawców DPA są dostępne w ich regulaminach lub automatycznie akceptowane podczas korzystania z usług.</p>

            <h2>6) Przekazywanie danych poza EOG</h2>
            <p>Część dostawców (np. Google, Vercel, Supabase, Resend) ma siedziby poza EOG. W takich przypadkach stosujemy mechanizmy wymagane przez RODO, m.in. Standardowe Klauzule Umowne (SCC) oraz dodatkowe zabezpieczenia techniczne (szyfrowanie, minimalizacja danych).</p>

            <h2>7) Okres przechowywania</h2>
            <ul className="list-disc ml-5 space-y-1">
              <li><strong>Dane konta i dane usługi</strong> – czas trwania umowy, a po jej zakończeniu do 6 miesięcy.</li>
              <li><strong>Dane płatności i księgowość</strong> – do 5 lat od końca roku podatkowego.</li>
              <li><strong>Logi techniczne</strong> – do 12 miesięcy.</li>
              <li><strong>Dane analityczne (GA4)</strong> – wg ustawień narzędzia (14–26 miesięcy) lub krócej, jeśli cofniesz zgodę.</li>
              <li><strong>Usunięcie konta przez Administratora Rodzinnego</strong> – w przypadku żądania usunięcia konta przez Administratora Rodzinnego dochodzi do nieodwracalnego usunięcia całej struktury Rodziny. Oznacza to, że Dane Rodzinne (w tym wpisy kalendarza i informacje o dzieciach) zostają usunięte dla wszystkich członków tej Rodziny. Administrator Rodzinny jest odpowiedzialny za poinformowanie pozostałych członków Rodziny o zamiarze usunięcia konta z wyprzedzeniem, aby umożliwić im skorzystanie z prawa do eksportu danych.</li>
            </ul>

            <h2>8) Dobrowolność podania danych</h2>
            <p>Podanie danych wymaganych do rejestracji i płatności jest konieczne do korzystania z usługi. Dane analityczne/cookies są dobrowolne.</p>

            <h2>9) Twoje prawa</h2>
            <p>Masz prawo do:</p>
            <ul className="list-disc ml-5 space-y-1">
              <li>dostępu, sprostowania, usunięcia, ograniczenia przetwarzania,</li>
              <li>przenoszenia danych,</li>
              <li>sprzeciwu wobec przetwarzania (gdy podstawą jest interes prawny),</li>
              <li>wycofania zgody w dowolnym momencie (bez wpływu na zgodność sprzed wycofania).</li>
            </ul>
            <p>Skargi możesz wnosić do organu nadzorczego: Prezes UODO, ul. Stawki 2, 00-193 Warszawa, <a href="https://uodo.gov.pl" target="_blank" rel="noopener noreferrer">uodo.gov.pl</a>.</p>

            <h2>10) Zabezpieczenia</h2>
            <p>Stosujemy m.in. szyfrowanie transmisji (TLS/HTTPS), haszowanie haseł, kontrolę dostępu i kopie zapasowe.</p>

            <h2>11) Dzieci</h2>
            <p>Serwis jest skierowany do osób pełnoletnich. Jeśli masz poniżej 16 lat, korzystaj z Serwisu wyłącznie za zgodą opiekuna.</p>

            <h2>12) Pliki cookie</h2>
            <p>Szczegóły znajdziesz w Polityce plików cookie dostępnej na stronie.</p>

            <h2>13) Zmiany Polityki</h2>
            <p>Polityka może być aktualizowana – data na górze wskazuje ostatnią wersję.</p>

            <h2>14) Kontakt</h2>
            <p>
              E‑mail: <a href="mailto:kontakt@2domy.pl">kontakt@2domy.pl</a><br />
              Adres: AITRAIN Marcin Opinc, ul. Kaszubska 6/21, 83-110 Tczew, Polska
            </p>
          </div>
        </div>
      </div>
    </Layout>
  )
}

export default PrivacyPolicy 